import { graphHooks } from '@tunasong/graph-lib/react'
import type { Entity, Persisted } from '@tunasong/schemas'
import { isBandSpace } from '@tunasong/schemas'
import { useSongBand } from '@tunasong/ui-layouts'
import { ProfileCardContext } from '@tunasong/ui-lib'
import type { ProfileCardBand } from '@tunasong/ui-lib'
import type { FC, ReactNode } from 'react'

export interface ProfileCardProviderProps {
  entity?: Persisted<Entity>
  children?: ReactNode
}

/**
 * Tells the profile cards under an open entity where the viewer is: the entity (for "Here now") and its band
 * (for each person's parts and the Owner badge). A bandspace is its own band; anything else uses the band
 * Perform resolves for it.
 */
export const ProfileCardProvider: FC<ProfileCardProviderProps> = ({ entity, children }) => {
  const isBand = isBandSpace(entity)
  const songBand = useSongBand(isBand ? undefined : entity)
  const bandRef = isBand && entity ? { id: entity.id, name: entity.name ?? 'your band' } : undefined
  const resolved = bandRef ?? (songBand.status === 'band' ? songBand.band : undefined)
  const { entity: bandEntity } = graphHooks.useEntity(resolved?.id)

  const band: ProfileCardBand | undefined = resolved ? { ...resolved, ownerId: bandEntity?.userId } : undefined

  return <ProfileCardContext.Provider value={{ entityId: entity?.id, band }}>{children}</ProfileCardContext.Provider>
}
